<div class="container">
  <h1>{{ isEdit ? 'Edit' : 'Add' }} Insurance</h1>
  
  <mat-card>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Insurance Information -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Insurance Contact</mat-label>
            <mat-select formControlName="contact_id" required>
              @for (contact of insuranceContacts(); track contact.id) {
                <mat-option [value]="contact.id">
                  {{ getContactDisplay(contact) }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Select the insurance contact</mat-hint>
            @if(form.get('contact_id')?.hasError('required')) {
              <mat-error>
                Insurance contact is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Face Value</mat-label>
            <input matInput type="text" formControlName="face_value" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the face value</mat-hint>
            @if(form.get('face_value')?.hasError('required')) {
              <mat-error>
                Face value is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Premium</mat-label>
            <input matInput type="text" formControlName="premium" required numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the premium</mat-hint>
            @if(form.get('premium')?.hasError('required')) {
              <mat-error>
                Premium is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cash Value</mat-label>
            <input matInput type="text" formControlName="cash_value" numberFormat required>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Enter the cash value amount</mat-hint>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Issue Date</mat-label>
            <input matInput [matDatepicker]="issuePicker" formControlName="issue_date" required>
            <mat-datepicker-toggle matSuffix [for]="issuePicker"></mat-datepicker-toggle>
            <mat-datepicker #issuePicker></mat-datepicker>
            <mat-hint>Select the issue date</mat-hint>
            @if(form.get('issue_date')?.hasError('required')) {
              <mat-error>
                Issue date is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Paid To Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="paid_to_date" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-hint>Select the paid to date</mat-hint>
            @if(form.get('paid_to_date')?.hasError('required')) {
              <mat-error>
                Paid to date is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <div class="full-width">
            <mat-checkbox formControlName="fundFromBank">Fund from Bank</mat-checkbox>
            <div class="checkbox-help-text">
              Check this to automatically create a transaction that subtract these funds from the selected bank (requires selecting a bank)
            </div>
          </div>
        </div>

        @if(form.get('fundFromBank')?.value) {
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Bank Account</mat-label>
              <mat-select formControlName="bank_id" [required]="form.get('fundFromBank')?.value">
                @for (bank of banks(); track bank.id) {
                  <mat-option [value]="bank.id">
                  {{ bank.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Select the bank account to fund from</mat-hint>
            @if(form.get('bank_id')?.hasError('required')) {
              <mat-error>
                Bank account is required when funding from bank
              </mat-error>
            }
          </mat-form-field>
        </div>
      }

        <!-- Form Actions -->
        <div class="form-actions">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
